const TURNSTILE_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";
const FORM_SELECTOR = "form[data-turnstile-sitekey]";
const PRELOAD_MARGIN = "400px 0px";

// Webflow injects the Turnstile script into <head> on every page that has a protected
// form. Hold that one script back until a form is about to be seen or used.
function deferTurnstile() {
  const head = document.head;
  const appendChild = head.appendChild;
  let heldScript = null;
  let observer = null;

  function release() {
    delete head.appendChild;
    observer?.disconnect();
    observer = null;

    if (!heldScript) return;

    const script = heldScript;
    heldScript = null;
    head.appendChild(script);
  }

  head.appendChild = function (node) {
    if (node?.tagName !== "SCRIPT" || node.src !== TURNSTILE_SRC) {
      return appendChild.call(this, node);
    }

    const forms = document.querySelectorAll(FORM_SELECTOR);
    if (!forms.length || !("IntersectionObserver" in window)) {
      delete head.appendChild;
      return appendChild.call(this, node);
    }

    heldScript = node;
    observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) release();
      },
      { rootMargin: PRELOAD_MARGIN }
    );

    forms.forEach((form) => {
      observer.observe(form);
      form.addEventListener("focusin", release, { once: true });
    });

    return node;
  };
}

deferTurnstile();
